// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Button, Group, Modal, Paper, Stack, Text } from '@mantine/core';
import { IconCalendarPlus, IconPhone } from '@tabler/icons-react';
import type { JSX } from 'react';

interface Props {
  opened: boolean;
  onClose: () => void;
  onCreateAppointment: () => void;
  onCreatePhoneEncounter: () => void;
}

export function CreateEncounterModal({
  opened,
  onClose,
  onCreateAppointment,
  onCreatePhoneEncounter,
}: Props): JSX.Element {
  return (
    <Modal opened={opened} onClose={onClose} title="Create Encounter" centered size="sm">
      <Stack gap="sm">
        <Text size="sm" c="dimmed">
          Choose encounter type for this patient.
        </Text>
        <Paper withBorder p="md" radius="md">
          <Group justify="space-between">
            <Stack gap={2}>
              <Text fw={600}>Create Appointment</Text>
              <Text size="xs" c="dimmed">
                Schedule a clinical visit.
              </Text>
            </Stack>
            <Button leftSection={<IconCalendarPlus size={16} />} onClick={onCreateAppointment}>
              Create Appointment
            </Button>
          </Group>
        </Paper>
        <Paper withBorder p="md" radius="md">
          <Group justify="space-between">
            <Stack gap={2}>
              <Text fw={600}>Create Phone Encounter</Text>
              <Text size="xs" c="dimmed">
                Add a short provider-attributed note.
              </Text>
            </Stack>
            <Button variant="light" color="dark" leftSection={<IconPhone size={16} />} onClick={onCreatePhoneEncounter}>
              Create Phone Encounter
            </Button>
          </Group>
        </Paper>
      </Stack>
    </Modal>
  );
}
